import { ref } from "vue"

let isSupported = ref(null)
let wasDetected = false
let supportResult

async function supportsWebp() {
  if (!self.createImageBitmap) return false;
  
  if (wasDetected) {
    return supportResult
  }

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then(r => r.blob());
  
    supportResult = await createImageBitmap(blob)
    wasDetected = true
  
    return supportResult
}

(async () => {
  if(await supportsWebp()) {
    isSupported.value = true
  }
  else {
     isSupported.value = false
  }
})()

export default isSupported;